import { api } from "api/api";
import { VeiculoRastreamento } from "model/transportes/rastreamento/VeiculoRastreamento";

export default class RastreamentoService {
    getVeiculoRastreamento() : Promise<VeiculoRastreamento[]> {
        return new Promise((resolve, reject) => {
            api.get('/rastreamento/veiculo')
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}